import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  public transform(value: string, limit: number, useWordBoundary: boolean = false): string {
    if (value.length <= limit) {
      return value;
    }
    const subString = value.slice(0, limit - 1);
    return (useWordBoundary ? subString.slice(0, subString.lastIndexOf(' ')) : subString) + '...';
  }
}
